export function formatPrice(price: number) {
    if (price <= 0) return 'FREE';
    return Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR' }).format(price);
}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/tools.ts